/*eslint-disable */

import axios from 'axios';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import root from '@/_helpers/roots';
import usrReqSendPopup from '@/components/users/usr-req-send-popup';
let memberUserListApiUrl = root.memberUserListApiUrl.link;
export default {
  name: 'all-users-list',
  components: {
    "usr-req-send-popup" : usrReqSendPopup
  },
  props: [],
  data () {
    return {
      memberAllUser:null,
      memberAllUserResults:[],
      isLoadMore:'',
      nextPageUrl:'',
      nextSteper:'',
      search_term:'',
      loader:false,
      usrConnectionReqPopupState:false,
      usrReqInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'getConnectionReqListGetters'
    ]),
    getMemberAllUserListFun() {
      this.memberAllUser = this.$store.getters.getConnectionReqListGetters.data;
      return
    },
    setInitialStatesFun(){
      if(this.memberAllUser){
        this.memberAllUserResults = this.memberAllUser.results
        this.nextSteper = this.memberAllUser.next
        this.nextPageUrl = this.memberAllUser.next
      }
    }
  },
  mounted () {
    this.getMemberAllUserListFun
    this.setInitialStatesFun
    bus.$on('usrConnectionReqPopupStateBus', (data) => {
        this.usrConnectionReqPopupState = data
    })  
  },
  methods: {
    usrConnectionReqSendMethod(data){
      this.usrReqInfo = data
      this.usrConnectionReqPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    validateSearchMemberBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.search_term.length >= 3){
            this.$store.dispatch('searchMemberUserAction', { search_term: this.search_term }).then((response) => {
              this.memberAllUserResults = []
              this.memberAllUser = response.data.data
              this.memberAllUserResults = this.memberAllUser.results
            })
          }else if(this.search_term.length == 0){
           axios.get(memberUserListApiUrl).then((response) => {
              this.memberAllUser = response.data.data
              this.memberAllUserResults = this.memberAllUser.results
            }).catch((err) => {
            })
          }
        }
      })
    },
    showLoadMoreDataFun(url) {
      this.loader = true
      axios.get(url).then((response) => {
          let loadmoreData = response.data
          this.nextSteper = loadmoreData.data.next
          this.$set(this.memberAllUserResults, 'next', this.nextSteper)
          if(loadmoreData){
            for (var i = 0; i < loadmoreData.data.results.length; i++) {
              this.memberAllUserResults.push(loadmoreData.data.results[i]);
              this.loader = false
            }
          }
        });
    },
  },
  watch:{
    nextSteper(old_val, new_val){
      if(!new_val) return;
      this.nextPageUrl = new_val
    },
    getMemberAllUserListFun() {
      return this.$store.getters.getConnectionReqListGetters;
    },
    setInitialStatesFun(){
      if(this.memberAllUser){
        this.memberAllUserResults = this.memberAllUser.results
      }
    },
  }
}